import { createContext, useContext, useEffect, useState } from 'react'
import NotificationServiceForBanners from '../services/notificationServiceForBanners'
import Banner from '../components/Frontend/genericComponents/banner/Banner'
// 1️⃣ Create the service singleton
export const bannerService = new NotificationServiceForBanners()

// 2️⃣ Context holds only the “showBanner” fn
const BannerContext = createContext({
  showBanner: ({ message, type, duration }) => {}
})

export function BannerProvider({ children }) {
  const [banners, setBanners] = useState([])

useEffect(() => {
  const timeouts = new Set();

  const handler = ({ message, title, type = 'info', duration = 3000 }) => {
    const id = Date.now().toString();
    setBanners(bs => [...bs, { id, title, message, type }]);

    const timeoutId = setTimeout(() => {
      setBanners(bs => bs.filter(b => b.id !== id));
      timeouts.delete(timeoutId); // clean up reference
    }, duration);

    timeouts.add(timeoutId);
  };

  bannerService.subscribe(handler);

  return () => {
    bannerService.unsubscribe(handler);
    timeouts.forEach(clearTimeout);
  };
}, []);
  // Expose the publish API
  const showBanner = payload =>{
    bannerService.publish(payload)}

  const removeBanner = id => setBanners(bs => bs.filter(b => b.id !== id))

  return (
    <BannerContext.Provider value={{ showBanner }}>
      {children}

      {/* banner container, adjust styling as you like */}
      <div style={{
        position: 'fixed',
        top: '4rem',
        right: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        zIndex: 1500
      }}>
        {banners.map(b => (
          <Banner
            key={b.id}
            type={b.type}
            title={b.title}
            message={b.message}
            onClose={() => removeBanner(b.id)}
          >
            {b.message}
          </Banner>
        ))}
      </div>
    </BannerContext.Provider>
  )
}

/**
 * Hook to fire a banner from anywhere in your tree.
 */
export function useBanner() {
  const ctx = useContext(BannerContext)
  if (!ctx) {
    throw new Error('useBanner must be used within a BannerProvider')
  }
  return ctx.showBanner
}
